export default function oppDuplicate(params){
    this.popup("oppDuplicate", {
        params: params, 
        header : this.translate("LBL_OPP_DUPLICATE", "Opportunities")
    });

}